import $ from 'jquery';

const DESIGNER_SHOP_ENDPOINT = '/content/myfav/designers/mobile';
var SELECTORS = {
    toggleBrandHeart: '.js-favorite-brand',
    submitHeartedBrands: '#submit-hearted-brands',
    toggleProductHeart: '.js-fav-item', // Used on trending product scroll for fav onboarding - step #3
    submitHeartedProducts : '#submit-hearted-products'
};

function init() {
    $(SELECTORS.toggleBrandHeart).click(toggleBrandHeart);
    $(SELECTORS.submitHeartedBrands).click(submitHeartedBrands);
    $(SELECTORS.toggleProductHeart).click(toggleProductHeart);
    $(SELECTORS.submitHeartedProducts).click(submitHeartedProducts);
}

var brands = [];
var products = [];

function toggleBrandHeart() {
    const activeContainerClass = 'favorite-button__container--active-clear';

    var brand = encodeURIComponent($(this).data('value'));

    if ($(this).hasClass(activeContainerClass)) {
        $(this).removeClass(activeContainerClass);
        brands.splice(brands.indexOf(brand), 1);
    } else {
        $(this).addClass(activeContainerClass);
        brands.push(brand);
    }
}

function submitHeartedBrands() {
    var isGuest = $('#myFavLimitPopup').data('isGuest');
    if (isGuest) {
        var favBrands = brands.map(function(brand) {
            return "favbrand=" + brand;
        }).join("&");
        $('#guestLimitPop, #fav-create-link').attr('href', "/r/mobile/LoginPage.jsp?" + favBrands +"&ref=" + encodeURIComponent(DESIGNER_SHOP_ENDPOINT + "?d=" + rcProps.department));
        $.modal({
            triggerOpen:true,
            open: "guestLimitPop"
        });
        return;
    }

    var bcodesParam = brands.map(function(brand) {
        return "bcodes=" + brand;
    }).join("&");

    var data = $.param({
        action_T: 'add',
        mensBrand: rcProps.department === "Mens"
    });

    $.ajax({
        type: 'POST',
        url: '/r/ajaxHeartProduct.jsp?' + bcodesParam,
        data: data,
        success: function() {
            var endpoint = DESIGNER_SHOP_ENDPOINT + "?d=" + rcProps.department;
            if( typeof gaUpdateHeartBrand === 'function') {
                var brandsDecoded = brands.map(function(brand) {
                    return decodeURIComponent(brand);
                });

                gaUpdateHeartBrand('add', brandsDecoded.join(","), function() {
                    location.href = endpoint;
                });
            } else {
                location.href = endpoint;
            }
        }
    });
}

function toggleProductHeart() {
    var activeButtonClass = window.rcProps && window.rcProps.favoriteActiveClass || "favorite-button--active";

    var product = $(this).data('value');
    if ($(this).hasClass(activeButtonClass)) {
        $(this).removeClass(activeButtonClass);
        products.splice(products.indexOf(product), 1);
    } else {
        $(this).addClass(activeButtonClass);
        products.push(product);
    }
}

function submitHeartedProducts() {
    var $this = $(this);
    var isGuest = $('#myFavLimitPopup').data('isGuest');
    if (isGuest) {
        var productCodeParams = "";
        if (products.length > 0) {
            for (var i=0; i< products.length; i++) {
                if (i == products.length - 1)
                    productCodeParams += "favcode=" + products[i];
                else
                    productCodeParams += "favcode=" + products[i] + "&";
            }
        }
        $('#guestLimitPop, #fav-create-link').attr('href', "/r/mobile/LoginPage.jsp?" + productCodeParams +"&ref=" + encodeURIComponent(window.location.pathname + window.location.search));
        $.modal({triggerOpen:true, open: "guestLimitPop"});
        return;
    }

    var pcodesParam = "";
    var pCodes = "";
    for (var i=0; i<products.length; i++) {
        var b = products[i];
        if (i == 0){
            pcodesParam += "pcodes=" + b;
            pCodes += b;
        }
        else {
            pcodesParam += "&pcodes=" + b;
            pCodes += "," + b;
        }
    }

    var data = $.param({
        action_T: 'add'
    });

    $.ajax({
        type: 'POST',
        url: '/r/ajaxHeartProduct.jsp?' + pcodesParam,
        data: data,
        success: function() {
            if (typeof iPinYouHeartItem === 'function') {
                iPinYouHeartItem(pCodes);
            }
            if (typeof gaUpdateHeartItem === 'function') {
                gaUpdateHeartItem('add',pCodes, function() {
                    location.href = '/r/mobile/mr_favorites.jsp?d=' + $this.data("department");
                });
            } else if(typeof taboolaWishListAction === 'function'){
                taboolaWishListAction('add',pCodes);
            }else
                location.href = '/r/mobile/mr_favorites.jsp?d=' + $this.data("department");
        }
    });
}

$(document).ready(function() {
    init();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/myfavonboard/index.js